export default {
    errorRun(msg) {
        alert(msg);
    },
    axiosErrorHandler(e) {
        if (e.response) {
            console.log(`${e.response.status}: ${e.response.data.err}`);
        } else {
            alert(e);
        }
    },
    processData(data) {
        // initializing values
        if (!data) {
            return [];
        }
        var dataSets = Object.values(Object.values(data))
        var dataArray = []
        var dataPoint = null

        // turns json object to 2-D array
        for (var i in dataSets) {
            for (var j in Object.values(dataSets[0])) {
                dataArray.push([])
                dataPoint = Object.values(dataSets[i])[j]
                dataArray[j].push(dataPoint)
            }
        }
        // removes empty elemnets from array
        dataArray = dataArray.filter(function (a) {
            return a.length != 0;
        });
        return dataArray;
    }
}
